import SchemeTypes from '../components/SchemeTypes';
import UpgradeTypes from '../components/UpgradeTypes';
import { generateTerrain } from '../functions/generateTerrain';
import {
  generatePlanet,
  generateStartLocation,
} from '../functions/generatePlanet';

export const initialState = {
  planet: {
    name: null,
    seed: 0,
    hue: 0,
    size: {},
    terrains: [],
    availableResources: [],
  },
  terrain: {
    seed: 0,
    hueRotate: 0,
    position: {
      x: 0,
      y: 0,
    },
    map: [],
    tiles: [],
  },
  upgrades: {
    total: 0,
    pointsAvailable: 0,
    tiers: [0, 20, 45, 60],
    tier1: UpgradeTypes,
  },
  schemes: SchemeTypes,
  inventory: {},
  settings: {
    windowOpen: false,
    autoSave: false,
  },
  resources: {
    coins: 0,
    gold: 0,
    energy: 0,
    weight: {
      current: 0,
      max: 10000,
    },
  },
  drill: {
    speed: 1,
    quality: 0,
    name: 'Basic Drill',
  },
  ui: {
    windows: [
      {
        id: 'header',
        name: 'Header',
        state: 'open',
        position: [0, 0],
      },
      {
        id: 'terrain',
        name: 'Terrain',
        state: 'open',
        position: [200, 200],
      },
      {
        id: 'schemes',
        name: 'Schemes',
        state: 'hidden',
        position: [400, 0],
      },
      {
        id: 'inventory',
        name: 'Inventory',
        state: 'hidden',
        position: [0, 300],
      },
      {
        id: 'upgrades',
        name: 'Upgrades',
        state: 'hidden',
        position: [300, 0],
      },
      {
        id: 'settings',
        name: 'Settings',
        state: 'hidden',
        position: [100, 0],
      },
    ],
    activeWindow: 'terrain',
    windowStack: [
      'header',
      'terrain',
      'schemes',
      'inventory',
      'upgrades',
      'settings',
    ],
  },
};
export function rootReducer(state = initialState, action) {
  switch (action.type) {
    case 'LOAD_GAME_STATE':
      return action.payload;

    case 'ADD_COINS':
      return {
        ...state,
        resources: {
          ...state.resources,
          coins: state.resources.coins + action.payload,
        },
      };

    case 'REMOVE_COINS':
      return {
        ...state,
        resources: {
          ...state.resources,
          coins: state.resources.coins - action.payload,
        },
      };

    case 'UPDATE_WEIGHT':
      return {
        ...state,
        resources: {
          ...state.resources,
          weight: {
            ...state.resources.weight,
            current: state.resources.weight.current + action.payload,
          },
        },
      };

    case 'ADD_ITEM_TO_INVENTORY':
      if (typeof state.inventory[action.payload.name] !== 'undefined') {
        return {
          ...state,
          inventory: {
            ...state.inventory,
            [action.payload.name]: {
              ...state.inventory[action.payload.name],
              value:
                state.inventory[action.payload.name].value +
                action.payload.value,
              weight:
                state.inventory[action.payload.name].weight +
                action.payload.weight,
            },
          },
        };
      } else {
        return {
          ...state,
          inventory: {
            ...state.inventory,
            [action.payload.name]: action.payload,
          },
        };
      }

    case 'REMOVE_ITEM_FROM_INVENTORY':
      return {
        ...state,
        inventory: {
          ...state.inventory,
          [action.payload.name]: {
            ...state.inventory[action.payload.name],
            value:
              state.inventory[action.payload.name].value - action.payload.value,
            weight:
              state.inventory[action.payload.name].weight -
              action.payload.weight,
          },
        },
      };

    case 'UPGRADE_ITEM':
      ++state.upgrades.total;
      switch (action.payload.type) {
        case 'qualityAdd':
          state.drill.quality += 1;
          break;
        case 'speedAdd':
          state.drill.speed += 1;
          break;
        case 'weightAdd':
          state.resources.weight.max += 1000;
          break;
        case 'scheme':
          state.schemes[action.payload.schemeID].researched = true;
          break;
        default:
          console.log('Unexpected switch statement');
          break;
      }
      return {
        ...state,
        upgrades: {
          ...state.upgrades,
          tier1: state.upgrades.tier1.map((item, index) => {
            if (index !== action.payload.id) {
              return item;
            }
            return {
              ...item,
              currentLevel: ++item.currentLevel,
              currentCost: Math.round(item.currentCost * item.multiplier),
            };
          }),
        },
      };

    case 'TOGGLE_SETTINGS_POPUP':
      return {
        ...state,
        settings: {
          ...state.settings,
          windowOpen: action.payload,
        },
      };

    case 'UPDATE_SETTINGS':
      return { ...state, settings: action.payload };

    case 'SET_WINDOW_POSITION':
      state.ui.windows.find((item) => item.id === action.payload.id).position =
        action.payload.coordinates;
      return {
        ...state,
        ui: {
          ...state.ui,
          windows: state.ui.windows,
        },
      };

    case 'SET_ACTIVE_WINDOW':
      return { ...state, ui: { ...state.ui, activeWindow: action.payload } };

    case 'UPDATE_WINDOWS':
      return { ...state, ui: { ...state.ui, windows: action.payload } };

    case 'UPDATE_WINDOW_STACK':
      console.log('payload:', action.payload);
      let ws = state.ui.windowStack.filter((i) => i !== action.payload);
      ws.push(action.payload);
      console.log('before', ws);
      return {
        ...state,
        ui: {
          ...state.ui,
          windowStack: ws,
        },
      };

    case 'GENERATE_START_LOCATION':
      const { coordinates } = generateStartLocation(action.payload);
      generateTerrain(
        { ...state.terrain, position: coordinates },
        action.payload
      );
      return {
        ...state,
        planet: action.payload,
        terrain: { ...state.terrain, position: coordinates },
      };

    case 'UPDATE_PLANET':
      generatePlanet(action.payload, action.position);
      return { ...state, planet: action.payload };

    case 'UPDATE_TERRAIN':
      generateTerrain(action.payload, action.planet);
      return {
        ...state,
        terrain: { ...action.payload, map: action.payload.map },
      };

    case 'UPDATE_TERRAIN_BLOCK':
      return {
        ...state,
        terrain: {
          ...state.terrain,
          map: state.terrain.map.map((item, index) => {
            if (index !== action.payload.id) {
              return item;
            }
            return {
              ...item,
              totalResources: action.payload.totalResources,
            };
          }),
        },
      };

    default:
      return state;
  }
}
